import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import ReCAPTCHA from "react-google-recaptcha";
import FormsInputsText from '../inputs/text/forms_inputs_text';
import ForgetPasswordSchema from './validation';

class FormsForgetPassword extends Component {
    state = {
        error: false,
        errorTitle: '',
        errorMessage: '',
        robot_token: ''
    }
    renderFormSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Completed</Message.Header>
                    <p>
                        A reset password email has been sent to the above email address if the email is existed in our system.
                        <br/>
                        <Link to="/">Go back to login page!</Link>
                    </p>
                </Message>
            );
        }
        if (this.state.error === true) {
            if(this.state.errorTitle && this.state.errorTitle == "Invalid Captcha"){
                return (
                    <Message negative>
                        <Message.Header>Captcha not Complete</Message.Header>
                        <p>
                            Please ensure the captha is done before proceeding.
                            <br/>
                        </p>
                    </Message>
                );
            }else{
                return (
                    <Message positive>
                        <Message.Header>Completed</Message.Header>
                        <p>
                            A reset password email has been sent to the above email address if the email is existed in our system.
                            <br/>
                            <Link to="/">Go back to login page!</Link>
                        </p>
                    </Message>
                );
            }
            
        }
    }
    render() {
        return (
            <Formik
                initialValues={{
                    email: '',
                    emailConfirm: ''
                }}
                validate={(values)=>{
                    console.log(values);

                    let error = {}

                    if (values.email.toLowerCase() !== values.emailConfirm.toLowerCase()) {
                        error.emailConfirm = 'The email addresses don\'t match. Please make sure the email addresses match.'
                    }

                    return error
                }}
                onSubmit={(values, actions) => {
                    var response = window.grecaptcha.getResponse();
                    console.log("response ", response)

                    // console.log(values, actions);
                    this.setState({error: false, errorMessage: '', success: false});
                    if(response == ''){
                        actions.setSubmitting(false);
                        this.setState({error: true, errorTitle: "Invalid Captcha", errorMessage: "Please verify your captcha"});
                    }else{
                        this.props.submitRequestResetPassword({email: values.email, robot_id: response}, (result, error) => {
                            if (error) {
                                actions.resetForm()
                                actions.setSubmitting(false);
                                this.setState({error: true, errorMessage: error.errorMessage, robot_token: ''});
                            }
                            if (result) {
                                window.grecaptcha.reset();
                                actions.resetForm();
                                actions.setSubmitting(false);
                                this.setState({error: false, success: true, errorMessage: null, robot_token: ''});
                            }
                        });
                    }
                    
                }}
                validateOnBlur={false}
                validateOnChange={false}
                validationSchema={ForgetPasswordSchema}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form>
                        <Message warning>
                            <p>
                                Please key in your registered email address to reset your password.
                            </p>
                        </Message>
                        <Field name="email" label="" component={FormsInputsText} secondaryLabel="Email Address"/>
                        <Field name="emailConfirm" label="" component={FormsInputsText} secondaryLabel="Re-enter Email Address"/>
                        &nbsp;
                        <ReCAPTCHA 
                            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                            onChange={(value) => {
                                if(value){
                                    this.setState({
                                        robot_token: value
                                    })
                                }
                            }}
                        />
                        &nbsp;
                        <Button type="submit" primary disabled={isSubmitting} fluid loading={isSubmitting}>Submit</Button>
                        {this.renderFormSubmissionResult()}
                    </Form>
                )}
            />
        );
    }
}

export default FormsForgetPassword;
